import React from 'react';

import { IconButton, Typography, Toolbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { RightDrawer, classes } from './persistent-right-modal.style';

export const PersistentRightModalContext = React.createContext<{
  showRightModal: boolean;
  setShowRightModal: (value: boolean) => void;
}>({
  showRightModal: false,
  setShowRightModal: () => {
    return;
  }
});

export function PersistentRightModal({
  children,
  onChange,
  open,
  title
}: {
  children: React.ReactNode;
  onChange: (value: boolean) => void;
  open: boolean;
  title: string;
}): JSX.Element {
  const onClose = (): void => onChange(false);

  return (
    <PersistentRightModalContext.Provider
      value={{
        showRightModal: open,
        setShowRightModal: React.useCallback((value): void => onChange(value), [onChange])
      }}
    >
      <RightDrawer
        variant='temporary'
        anchor='right'
        open={open}
        onClose={(_, reason: 'backdropClick' | 'escapeKeyDown'): void => {
          if (reason === 'backdropClick') {
            return;
          }
          onClose();
        }}
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <Toolbar className={classes.dialogToolbar}>
          <Typography variant='h2' className={classes.colorWhite}>
            {title}
          </Typography>
          <div className={classes.grow} />
          <IconButton onClick={onClose} className={classes.colorWhite} aria-label='close'>
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <div className={classes.content}>{open ? children : null}</div>
      </RightDrawer>
    </PersistentRightModalContext.Provider>
  );
}
